import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
// import MubitDelivery from '../../../assets/images/mubit_delivery.webp'
import Portada from './portada.jpg'
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight'
import { Link } from 'react-router-dom'
import Routes from '../../../routes'
import { isIOS, isSafari } from 'mobile-device-detect';
import Fork from '../../../utils/Fork'

const styles = StyleSheet.create({
    hero: {
        backgroundColor: '#d4e8f5',
        color: '#fff'
    },
    title: {
        color: '#193f83',
        fontWeight: 900
    },
    textGray: {
        color: '#667078'
    },
    textBlack: {
        color: '#000',
        fontWeight: '700'
    },
    cta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 30px',
        fontWeight: '700',
        fontSize: '20px',

    },
    subcta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '5px 15px',
        fontWeight: '700',
        fontSize: '18px',

    },
    image: {
        boxShadow: '20px -13px #78C0E0'

    },
    flexy: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
        paddingBottom: 40
    },
    ctaDiv: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        marginTop: '10px'
    },
    highlight: {
        backgroundColor: '#78bfe0',
        fontWeight: 300,
        padding: '2px'
    },
    bold: {
        fontWeight: '900'
    }
});


class Hero extends Component {



    sendToCotizador = () => {
        return `/${this.props.online_to}`
    }

    onSubmitConvertion = (redirectoTo, convertionMethod) => {
        this.props.setLoading(true)
        var tracked = window.mixpanel.track('Landings', {
            'site': this.props.site,
            'variation': this.props.variation,
            'convertion_method': convertionMethod,
            'convertion_value': redirectoTo
        })
        console.log('TRACKED', tracked)
        window.location.href = redirectoTo;

    }

    render() {
        return (
            <div className={css(styles.hero)} >
                <Container fluid={false} >
                    <Row className="py-5">
                        <Col xs={12} md={6} className={css(styles.flexy)} >
                            <h1 className={css(styles.title)}>Tu bodega con la más alta tecnología y comodidad.</h1>
                            <p className={css(styles.textBlack) + " lead mb-1"}>
                                ¡Guarda todo lo que quieras, sin mover un dedo!
                            </p>
                            <p className={css(styles.textGray) + " lead"}>
                                Nuestros especialistas irán hasta la puerta de tu hogar para proteger y almacenar todo lo que quieras guardar, inventariando con fotos todas tus cosas.
                            </p>
                            <div className={css(styles.ctaDiv)}>
                                <Button onClick={() => {
                                    this.onSubmitConvertion(this.sendToCotizador(), 'online')
                                }} className={css(styles.cta) + ""}>Contratar en línea <FaArrowRight /></Button>
                            </div>
                            <div className={css(styles.ctaDiv)}>
                                <Button onClick={() => {
                                    this.onSubmitConvertion(Routes.CotizaAsesor.url, 'asesor')
                                }} className={css(styles.subcta) + ""}>Cotizar con asesor</Button>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div>
                                {isIOS && <img type="image/png" className={css(styles.image) + " img-fluid"} src={Portada} alt="Almacenamiento Seguro" />}
                                {isSafari && <img type="image/png" className={css(styles.image) + " img-fluid"} src={Portada} alt="Almacenamiento Seguro" />}
                                {!isIOS && <img type="image/webp" className={css(styles.image) + " img-fluid"} src={Portada} alt="Almacenamiento Seguro" />}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Hero;